import React from "react";
import BodyContentHeader from "../common/BodyContentHeader";
import "./Portfolio.scss";

const About = () => {
  return (
    <div>
      <BodyContentHeader
        headerTitle="About Thorya"
        headerSubtitle="The cat's name is Stinky."
        imgSrc="self_portrait.png"
        imgAlt="self portrait"
      />
      <div id="case_study_container">
        <div className="case_study_section_1_col">
          <div className="case_study_row_subsection">
            <div style={{ width: "1000px", maxWidth: "100%", margin: "auto" }}>
              <h2>Hi there!</h2>
              <br />
              <h3>
                I&apos;m Thorya Aadland (pronounced TORE-yuh ODD-lund), and
                I&apos;m a Senior UX Engineer currently studying for a Msc. in
                Informatics at the Technical University of Munich.
              </h3>
              <br />
              <h3>
                Over the years, I have had to wear many different hats.
                Primarily focused on startups, I learned skills as needed to
                fill specialized gaps in very small teams. As a result, I can do
                full-stack development, mobile app development, UI/UX design,
                and user research. I&apos;m a great asset to any team that needs
                someone who can do a little bit of everything, or learn
                something on the fly.
              </h3>
              <br />
              <h3>
                I&apos;m particularly passionate about frontend development and
                user experience.
              </h3>
              <br />
              <h3>As you can probably tell, I also love space and cats.</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
